import { ReactNode, useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import { CollectionPointSearchParams } from '../../../../../types/collectionPoints';
import { config } from '../../../../../utils/config';
import InputWithIconAndButton from '../../../../atoms/InputWithIconAndButton';
import { getSearchParamsFromPlace } from '../searchUtils';
import './style.scss';

type AutocompleteSearchSectionProps = {
  onSearch: (searchParams: CollectionPointSearchParams) => Promise<void>;
  initialValues: CollectionPointSearchParams;
  isLoading?: boolean;
  isGoogleMapsSdkLoaded: boolean;
  filters: ReactNode;
  dropdown: ReactNode;
};

const AutocompleteSearchSection = ({
  onSearch,
  initialValues,
  isLoading,
  isGoogleMapsSdkLoaded,
  filters,
  dropdown,
}: AutocompleteSearchSectionProps) => {
  const { formatMessage } = useIntl();
  const inputRef = useRef<HTMLInputElement>(null);
  const [value, setValue] = useState(initialValues.formattedAddress);
  useEffect(() => {
    setValue(initialValues.formattedAddress);
  }, [initialValues.formattedAddress]);
  useEffect(() => {
    if (!isGoogleMapsSdkLoaded) {
      return;
    }
    const autocomplete = new google.maps.places.Autocomplete(inputRef.current!, {
      componentRestrictions: { country: [config.country] },
      fields: ['address_components', 'geometry'],
      types: ['address'],
    });
    autocomplete.addListener('place_changed', () => {
      const place = autocomplete.getPlace();
      const searchParams = getSearchParamsFromPlace(place);
      if (!searchParams) {
        return;
      }
      setValue(searchParams.formattedAddress);
      onSearch(searchParams);
    });
  }, [isGoogleMapsSdkLoaded]);
  return (
    <>
      <div className="collection-point-search-section">
        <InputWithIconAndButton
          isLoading={isLoading}
          placeholder={formatMessage({ id: 'generic.search' })}
          inputref={inputRef}
          value={value}
          onChange={e => setValue(e.currentTarget.value)}
          button={{
            text: 'generic.clear',
            onClick: () => setValue(''),
          }}
          autoFocus
        />
      </div>
      {filters}
      {!value && dropdown}
    </>
  );
};

export default AutocompleteSearchSection;
